import manualFront from './manual/front.json';
import manualDiagonal from './manual/diagonal.json';
import manualBack from './manual/back.json';

export default {
  manual: {
    'identity-document-front': manualFront,
    'identity-document-diagonal': manualDiagonal,
    'identity-document-back': manualBack
  }
};
